<template>
	<div>
		<div class="login-nav claearfix">
			<div class="login-logo">
				<a href="#">
					<img src="../assets/logo.png" class="logo">
				</a>
			</div>
			<!-- <div class="login-nav-box">
				<nav>
					<ul>
						<li>
							<a href="http://www.idaonline.org/">首頁</a>
						</li>
						<li>
							<a href="http://www.idaonline.org/about_ida/">關於IDA</a>
						</li>
						<li>
							<a href="http://www.idaonline.org/ida_m/">我與IDA有約</a>
						</li>
						<li>
							<a href="http://www.idaonline.org/2018/09/03/2019ida/">IDA資訊</a>
						</li>
						<li>
							<a href="http://www.idaonline.org/member/">IDA名人錄</a>
						</li>
						<li>
							<a href="http://app.chrp-org.com:8081/project/index.html">會員登錄</a>
						</li>
					</ul>
				</nav>
			</div> -->
			
			<div class="login-nav-box">
				<nav>
					<ul>
						<li>
							<a href="http://www.idaonline.org/">首頁</a>
						</li>
						<li>
							<a href="http://www.idaonline.org/?modules=About&Left=1&ID=4">關於IDA</a>
						</li>
						<li>
							<a href="http://www.idaonline.org/?modules=Assignation&Left=1">我與IDA有約</a>
						</li>
						<li>
							<a href="http://www.idaonline.org/?modules=data">IDA資訊</a>
						</li>
						<li>
							<a href="http://www.idaonline.org/?modules=Celeb">IDA名人錄</a>
						</li>
						<li>
							<a href="http://app.chrp-org.com:8081/project/index.html">會員登錄</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>
		<div class="poster">
			<img src="../assets/banner.jpg" class="logo">
		</div>
	</div>
</template>
<script>
	export default {
		name: 'loginNav',
		data () {
    		return {
    			
    		}
    	},
		created(){},
		methods:{},
	}
</script>
<style>
.login-nav{
	padding:0 25px;
}
.login-logo{
	float:left;
	margin:15px 0;
	width:60px;
}
.login-logo a{
	display:block;

}
.login-logo img{
	width:100%;
}
.login-nav-box{
	float:right;
}

nav li{float:left;}
nav li a{
	display:block;
	line-height:90px;
	padding:0 20px;
	text-decoration: none;
	color: #354346;
	font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
}
nav li a:hover{
	color: #c89c56;
}
.poster{
	width:100%;
	overflow:hidden;
}
.poster img{
	width:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/loginNav.vue